import { create } from './BaseService';

const http = create({});

export const goldPriceService = (startDate:any, endDate:any): any => {
    return http.post(`/goldPrice`, {startDate, endDate});
  };
